import React from 'react';
import { ModalProvider } from '@idexio/dev-idex-swap-uikit';
import { Web3ReactProvider } from '@web3-react/core';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { getLibrary } from 'utils/web3React';
import { LanguageContextProvider } from 'contexts/Localisation/languageContext';
import { ThemeContextProvider } from 'contexts/ThemeContext';
import { RefreshContextProvider } from 'contexts/RefreshContext';
import store from 'state';

const Providers: React.FC = ({ children }) => {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Provider store={store}>
        <HelmetProvider>
          <ThemeContextProvider>
            <LanguageContextProvider>
              <RefreshContextProvider>
                <ModalProvider>{children}</ModalProvider>
              </RefreshContextProvider>
            </LanguageContextProvider>
          </ThemeContextProvider>
        </HelmetProvider>
      </Provider>
    </Web3ReactProvider>
  );
};

export default Providers;
